<template>
    <div class="partner-row-placeholder">
        <div class="logo-placeholder"></div>
    </div>
</template>

<script>
export default {
    name: 'PartnerRowPlaceholder',
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.partner-row-placeholder {
    margin-bottom: 16px;
    background-color: white;
    position: relative;
    z-index: 20;
    width: 100%;
    height: 178px;
    display: grid;
    grid-template-columns: 40% auto 136px;
    @include mq('tablet') {
        padding: 20px;
        column-gap: 20px;
        align-items: center;
        grid-template: 1fr/112px 1fr minmax(108px, 160px) minmax(160px, 170px);
        margin-bottom: 20px;
        height: 155px;
    }
    box-shadow: 4px 4px 14px rgba(70, 69, 70, 0.25);
    border-radius: 5px;
}

.logo-placeholder {
    background: #999;
    grid-column: 1;
    grid-row: 1;
    border-radius: 5px;
    height: 90px;
    box-shadow: 2px 2px 10px rgba(70, 69, 70, 0.25);
    margin: 18px 10px 10px;
    width: 90px;
    justify-self: center;

    @include mq('tablet') {
        margin: 0;
        display: flex;
        width: 100%;
        height: 100px;
        padding: 10px;
    }
}
</style>
